var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloudArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_2084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16L12.5 12L8.5 16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12V21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.89 18.39C21.8653 17.8583 22.6358 17.0169 23.0798 15.9986C23.5239 14.9804 23.6162 13.8432 23.3422 12.7667C23.0682 11.6902 22.4434 10.7355 21.5666 10.0535C20.6898 9.3714 19.6108 9.00075 18.5 9.00001H17.24C16.9373 7.82926 16.3731 6.74235 15.5899 5.82101C14.8067 4.89967 13.8248 4.16786 12.7181 3.68062C11.6113 3.19338 10.4085 2.96337 9.20008 3.0079C7.99164 3.05242 6.80903 3.37031 5.74114 3.93768C4.67325 4.50505 3.74787 5.30712 3.03458 6.2836C2.32129 7.26008 1.83865 8.38555 1.62294 9.57541C1.40723 10.7653 1.46407 11.9885 1.78917 13.1533C2.11428 14.318 2.6992 15.3939 3.49996 16.3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16L12.5 12L8.5 16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_2084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloudArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CloudArrow.2237a238.svg";
export { ForwardRef as ReactComponent };